import { Box, Grid, Typography, Dialog } from '@mui/material'
import React, { useState, useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { ContextoGlobal, ContextoGlobalInterface } from '../../GlobalStates/ContextoGlobal'
import { MensagemTipo } from '../../GlobalStates/MensagemState'
import { RespostaPadraoInterface } from '../../ImportBackend/Interfaces/PadraoInterfaces'
import BackEndAPI from '../../Services/BackEndAPI'
import { ClienteInterface } from '../../ImportBackend/Interfaces/ClienteInterfaces'
import DataTable, { DataTableCabecalhoInterface } from '../../DevComponents/DataTable'

export default function SetCliente() {

  const contexto = useContext(ContextoGlobal) as ContextoGlobalInterface
  const { mensagemState, setMensagemState } = contexto
  const { loginState, setLoginState } = contexto

  const Cabecalho: Array<DataTableCabecalhoInterface> = [{
    campo: 'razaoSocial',
    cabecalho: 'Razão Social',
    alinhamento: 'left'
  },
  {
    campo: 'nomeFantasia',
    cabecalho: 'Nome Fantasia',
    alinhamento: 'left'
  }
  ]

  const [rsClientes, setRsClientes] = useState<Array<ClienteInterface>>([])

  const clsApi: BackEndAPI = new BackEndAPI()

  const navigate = useNavigate()

  const btFechar = () => {
    navigate('/')
  }

  const setCliente = (rsCliente: ClienteInterface) => {

    const idCliente: number = rsCliente && rsCliente.idCliente && rsCliente.idCliente !== 0 ? rsCliente.idCliente : 0

    if (idCliente !== 0) {

      const mutation = `
        setUsuarioCliente(idCliente: ${idCliente}) {
          ok
          mensagem
        }
      `

      clsApi.mutation<RespostaPadraoInterface>(mutation, 'setUsuarioCliente', 'Alterando Cliente...', contexto).then(rs => {

        if (rs.ok) {
          setLoginState({ ...loginState, idClienteAtual: idCliente })
        } else {
          setLoginState({ ...loginState, idClienteAtual: 0 })
        }

      }).catch(() => {

        setMensagemState({
          ...mensagemState,
          titulo: 'Erro! Consulte Suporte!',
          exibir: true,
          mensagem: 'Erro ao Alterar Cliente do Usuário!',
          tipo: MensagemTipo.Error,
          exibirBotao: true
        })

      })

    }

  }

  const pesquisarUsuarioClientes = () => {
    const query = `
      getUsuarioClientesPermitidosPorAcesso {
        idCliente
        razaoSocial
        nomeFantasia
      }
    `

    clsApi.query<Array<ClienteInterface>>(query, 'getUsuarioClientesPermitidosPorAcesso', 'Recebendo Clientes...', contexto).then(rsClientes => {

      setRsClientes(rsClientes)

      if (rsClientes.length === 1) {
        setCliente(rsClientes[0])
        btFechar()
      }

    }).catch(() => {

      setMensagemState({
        ...mensagemState,
        titulo: 'Erro! Consulte Suporte!',
        exibir: true,
        mensagem: 'Erro ao Consultar Clientes de Usuários!',
        tipo: MensagemTipo.Error,
        exibirBotao: true
      })

    })

  }

  useEffect(() => {

    pesquisarUsuarioClientes()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onChangeCliente = (v: ClienteInterface) => {

    if (v) {
      setCliente(v)
      btFechar()
    }

  }

  return (
    <>

      <Dialog
        sx={{ '& .MuiDialog-paper': { height: 600 } }}
        fullWidth
        open={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >

        <Box
          sx={{ backgroundColor: 'white', padding: 2, mx: 5 }}
        >
          <Grid container>

            <Grid item textAlign='center'>
              <Typography variant="h5" fontFamily='sans-serif' fontWeight='bolder' color="primary.main">
                Selecione uma Empresa
              </Typography>
            </Grid>

            <Grid item xs={12}>

              <DataTable<ClienteInterface>
                cabecalho={Cabecalho}
                dados={rsClientes}
                onSelecionarLinha={(v: any) => onChangeCliente(v)}
                rowsPerPageOptions={[100]}
                currentPageOptions={{ page: 0, rowsPerPage: 100 }}
                acoes={[{ icone: 'check', corIcone: 'green', toolTip: 'Selecionar Cliente', onAcionador: (v) => onChangeCliente(v) }]}
              // rowsPerPageOptions={[{ value: rsClientes.length, label: 'Todos' }]}
              // currentPageOptions={{ page: 0, rowsPerPage: rsClientes.length }}
              />

            </Grid>
          </Grid>
        </Box>

      </Dialog>
    </>
  )

}